module.exports = "/fonts/Lato-Regular.woff?1d2ca94dfba6f8d87cfda33b32f0febc";